import { useEffect, useState } from "react";
import { X } from "lucide-react";
import { useGuide } from "@/lib/guide";

const findTarget = (id) => document.querySelector(`[data-testid="${id}"]`);

export const Tour = () => {
  const { tour, setTour, markDone } = useGuide();
  const [rect, setRect] = useState(null);
  const step = tour && tour.module.tour[tour.i];
  useEffect(() => {
    if (!step) return undefined;
    let tries = 0;
    const locate = () => {
      const el = findTarget(step.target);
      if (el) { el.scrollIntoView({ behavior: "smooth", block: "center" }); setTimeout(() => setRect(el.getBoundingClientRect()), 350); }
      else if (tries++ < 10) setTimeout(locate, 200);
      else setRect(null);
    };
    setRect(null); locate();
    const onResize = () => { const el = findTarget(step.target); el && setRect(el.getBoundingClientRect()); };
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, [step]);
  if (!step) return null;
  const n = tour.module.tour.length;
  const last = tour.i === n - 1;
  const close = () => setTour(null);
  const next = () => (last ? (markDone(tour.module.id), close()) : setTour({ ...tour, i: tour.i + 1 }));
  const pad = 8;
  const vw = window.innerWidth, vh = window.innerHeight;
  const below = rect && rect.bottom + 190 < vh;
  const cardStyle = rect
    ? { top: below ? rect.bottom + pad + 8 : Math.max(12, rect.top - pad - 180), left: Math.min(Math.max(12, rect.left), vw - Math.min(340, vw - 24) - 12) }
    : { top: vh / 2 - 90, left: vw / 2 - Math.min(340, vw - 24) / 2 };
  return (
    <div className="fixed inset-0 z-[80]" data-testid="guide-tour">
      {rect ? (
        <div className="absolute rounded-xl transition-[top,left,width,height] duration-300 pointer-events-none ring-2 ring-[#D4FF3A]"
          style={{ top: rect.top - pad, left: rect.left - pad, width: rect.width + pad * 2, height: rect.height + pad * 2, boxShadow: "0 0 0 9999px rgba(3,3,5,0.72)" }} />
      ) : <div className="absolute inset-0 bg-[#030305]/70" />}
      <div className="absolute w-[min(340px,calc(100vw-24px))] rounded-2xl border border-white/10 bg-[#0A0A0F] p-4 shadow-2xl mh-enter" style={cardStyle} data-testid="guide-tour-card">
        <div className="flex items-center justify-between font-mono text-[10px] text-muted-foreground"><span>{tour.module.title} · {tour.i + 1}/{n}</span>
          <button onClick={close} aria-label="Close tour" data-testid="guide-tour-close" className="hover:text-foreground"><X className="w-4 h-4" /></button></div>
        <div className="text-base font-medium mt-1.5" data-testid="guide-tour-title">{step.title}</div>
        <p className="text-sm text-muted-foreground mt-1">{step.body}{!rect && " (This part isn't on screen right now; it appears once there's data.)"}</p>
        <div className="flex justify-between items-center mt-4">
          <button onClick={() => setTour({ ...tour, i: Math.max(0, tour.i - 1) })} disabled={tour.i === 0} className="text-xs text-muted-foreground disabled:opacity-30" data-testid="guide-tour-back">Back</button>
          <button onClick={next} className="h-8 px-4 rounded-full bg-[#D4FF3A] text-black text-xs font-semibold" data-testid="guide-tour-next">{last ? "Finish" : "Next"}</button>
        </div>
      </div>
    </div>
  );
};
